module.exports = __webpack_public_path__ + "img/fz_cszc.10b6a88b.png";